import RPCert from "./certificate";

const templates = [
  {
    id: "certificate",
    label: "Certificate",
    template: RPCert
  }
];

export default templates;
